// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3mysC","title":"Info_title__17wQD","selects":"Info_selects__oDCJv","requiredAsterisk":"Info_requiredAsterisk__1cwO8"};